var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg500InternalServerErrorRafiki(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-44"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 26,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.33,
    y: 389.21,
    width: 54.1,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.46,
    y: 401.21,
    width: 26.32,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.67,
    y: 399.53,
    width: 19.23,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.47,
    y: 399.53,
    width: 30.29,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.23,
    y: 395.31,
    width: 54.56,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.19,149.61H312.76l-9.59,9.59V372.81l9.59,9.59h69.43l9.59-9.59V159.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.17 372.81 312.76 382.4 334.29 382.4 324.7 372.81 303.17 372.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.17 159.2 312.76 149.61 334.29 149.61 324.7 159.2 303.17 159.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.41,149.61H334.29l-9.59,9.59V372.81l9.59,9.59h86.12c3.74-3.75,5.84-5.85,9.59-9.59V159.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.51 377.92 329.18 371.59 329.18 160.42 335.51 154.09 419.19 154.09 425.52 160.42 425.52 371.59 419.19 377.92 335.51 377.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 165.45,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,352.91a.81.81,0,1,0,.81-.8A.81.81,0,0,0,420.33,352.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,352.91a.8.8,0,1,0,.8-.8A.8.8,0,0,0,416.48,352.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,352.91a.8.8,0,1,0,.8-.8A.8.8,0,0,0,412.62,352.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 172.9,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 165.45,
    width: 4.48,
    height: 18.5,
    transform: "translate(662.84 349.4) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 185.74,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,332.62a.81.81,0,1,0,.81-.8A.81.81,0,0,0,420.33,332.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,332.62a.8.8,0,1,0,.8-.8A.8.8,0,0,0,416.48,332.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,332.62a.8.8,0,1,0,.8-.8A.8.8,0,0,0,412.62,332.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 193.19,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 185.74,
    width: 4.48,
    height: 18.5,
    transform: "translate(662.84 389.98) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 206.03,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,312.34a.81.81,0,1,0,.81-.81A.8.8,0,0,0,420.33,312.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,312.34a.8.8,0,1,0,1.6,0,.8.8,0,1,0-1.6,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,312.34a.8.8,0,1,0,.8-.81A.8.8,0,0,0,412.62,312.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 213.48,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 206.03,
    width: 4.48,
    height: 18.5,
    transform: "translate(662.84 430.56) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 226.32,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,292.05a.81.81,0,1,0,.81-.81A.8.8,0,0,0,420.33,292.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,292.05a.8.8,0,1,0,1.6,0,.8.8,0,1,0-1.6,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,292.05a.8.8,0,1,0,.8-.81A.8.8,0,0,0,412.62,292.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 233.77,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 226.32,
    width: 4.48,
    height: 18.5,
    transform: "translate(662.84 471.14) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 246.61,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,271.76a.81.81,0,1,0,.81-.81A.8.8,0,0,0,420.33,271.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,271.76a.8.8,0,1,0,1.6,0,.8.8,0,1,0-1.6,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,271.76a.8.8,0,1,0,.8-.81A.8.8,0,0,0,412.62,271.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 254.06,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 246.61,
    width: 4.48,
    height: 18.5,
    transform: "translate(662.84 511.72) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 266.9,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,251.47a.81.81,0,0,0,1.61,0,.81.81,0,0,0-1.61,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,251.47a.8.8,0,1,0,.8-.8A.8.8,0,0,0,416.48,251.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,251.47a.8.8,0,1,0,.8-.8A.8.8,0,0,0,412.62,251.47Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 274.35,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 266.9,
    width: 4.48,
    height: 18.5,
    transform: "translate(662.84 552.3) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 287.19,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,231.18a.81.81,0,1,0,.81-.8A.8.8,0,0,0,420.33,231.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,231.18a.8.8,0,1,0,.8-.8A.8.8,0,0,0,416.48,231.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,231.18a.8.8,0,1,0,.8-.8A.8.8,0,0,0,412.62,231.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 294.64,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 287.19,
    width: 4.48,
    height: 18.5,
    transform: "translate(662.84 592.88) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 307.48,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,210.89a.81.81,0,1,0,.81-.8A.8.8,0,0,0,420.33,210.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,210.89a.8.8,0,1,0,.8-.8A.8.8,0,0,0,416.48,210.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,210.89a.8.8,0,1,0,.8-.8A.8.8,0,0,0,412.62,210.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 314.93,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 307.48,
    width: 4.48,
    height: 18.5,
    transform: "translate(662.84 633.45) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 327.77,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,190.6a.81.81,0,1,0,.81-.8A.8.8,0,0,0,420.33,190.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,190.6a.8.8,0,1,0,.8-.8A.8.8,0,0,0,416.48,190.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,190.6a.8.8,0,1,0,.8-.8A.8.8,0,0,0,412.62,190.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 335.22,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 327.77,
    width: 4.48,
    height: 18.5,
    transform: "translate(662.84 674.03) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 348.06,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,170.31a.81.81,0,1,0,.81-.8A.8.8,0,0,0,420.33,170.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,170.31a.8.8,0,1,0,.8-.8A.8.8,0,0,0,416.48,170.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.62,170.31a.8.8,0,1,0,.8-.8A.8.8,0,0,0,412.62,170.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 355.51,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 348.06,
    width: 4.48,
    height: 18.5,
    transform: "translate(662.84 714.61) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.61,149.61H196.18l-9.6,9.59V372.81l9.6,9.59h69.43l9.59-9.59V159.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.59 372.81 196.18 382.4 217.71 382.4 208.12 372.81 186.59 372.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.59 159.2 196.18 149.61 217.71 149.61 208.12 159.2 186.59 159.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.82,149.61H217.71l-9.59,9.59V372.81l9.59,9.59h86.11l9.6-9.59V159.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.93 377.92 212.6 371.59 212.6 160.42 218.93 154.09 302.6 154.09 308.94 160.42 308.94 371.59 302.6 377.92 218.93 377.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 165.45,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,170.31a.8.8,0,1,1,.8.8A.8.8,0,0,1,303.75,170.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,170.31a.81.81,0,1,1,.8.8A.8.8,0,0,1,299.89,170.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,170.31a.81.81,0,1,1,.8.8A.8.8,0,0,1,296,170.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 172.9,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 165.45,
    width: 4.48,
    height: 18.5,
    transform: "translate(429.67 349.4) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 185.74,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,190.6a.8.8,0,1,1,.8.8A.8.8,0,0,1,303.75,190.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,190.6a.81.81,0,1,1,.8.8A.8.8,0,0,1,299.89,190.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,190.6a.81.81,0,1,1,.8.8A.8.8,0,0,1,296,190.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 193.19,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 185.74,
    width: 4.48,
    height: 18.5,
    transform: "translate(429.67 389.98) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 206.03,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,210.89a.8.8,0,1,1,.8.8A.8.8,0,0,1,303.75,210.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,210.89a.81.81,0,1,1,.8.8A.8.8,0,0,1,299.89,210.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,210.89a.81.81,0,1,1,.8.8A.8.8,0,0,1,296,210.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 213.48,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 206.03,
    width: 4.48,
    height: 18.5,
    transform: "translate(429.67 430.56) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 226.32,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,231.18a.8.8,0,1,1,.8.8A.8.8,0,0,1,303.75,231.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,231.18a.81.81,0,1,1,.8.8A.8.8,0,0,1,299.89,231.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,231.18a.81.81,0,1,1,.8.8A.8.8,0,0,1,296,231.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 233.77,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 226.32,
    width: 4.48,
    height: 18.5,
    transform: "translate(429.67 471.14) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 246.61,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,251.47a.8.8,0,1,1,.8.8A.8.8,0,0,1,303.75,251.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,251.47a.81.81,0,0,1,1.61,0,.81.81,0,0,1-1.61,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,251.47a.81.81,0,0,1,1.61,0,.81.81,0,0,1-1.61,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 254.06,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 246.61,
    width: 4.48,
    height: 18.5,
    transform: "translate(429.67 511.72) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 266.9,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,271.76a.8.8,0,1,1,.8.8A.8.8,0,0,1,303.75,271.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,271.76a.81.81,0,1,1,.8.8A.8.8,0,0,1,299.89,271.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,271.76a.81.81,0,1,1,.8.8A.8.8,0,0,1,296,271.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 274.35,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 266.9,
    width: 4.48,
    height: 18.5,
    transform: "translate(429.67 552.3) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 287.19,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,292.05a.8.8,0,1,1,.8.8A.8.8,0,0,1,303.75,292.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,292.05a.81.81,0,1,1,.8.8A.8.8,0,0,1,299.89,292.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,292.05a.81.81,0,1,1,.8.8A.8.8,0,0,1,296,292.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 294.64,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 287.19,
    width: 4.48,
    height: 18.5,
    transform: "translate(429.67 592.88) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 307.48,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,312.34a.8.8,0,1,1,.8.8A.8.8,0,0,1,303.75,312.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,312.34a.81.81,0,1,1,.8.8A.8.8,0,0,1,299.89,312.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,312.34a.81.81,0,1,1,.8.8A.8.8,0,0,1,296,312.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 314.93,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 307.48,
    width: 4.48,
    height: 18.5,
    transform: "translate(429.67 633.45) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 327.77,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,332.62a.8.8,0,1,1,.8.81A.8.8,0,0,1,303.75,332.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,332.62a.81.81,0,1,1,.8.81A.8.8,0,0,1,299.89,332.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,332.62a.81.81,0,1,1,.8.81A.8.8,0,0,1,296,332.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 335.22,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 327.77,
    width: 4.48,
    height: 18.5,
    transform: "translate(429.67 674.03) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 348.06,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,352.91a.8.8,0,1,1,.8.81A.8.8,0,0,1,303.75,352.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,352.91a.81.81,0,1,1,.8.81A.8.8,0,0,1,299.89,352.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,352.91a.81.81,0,1,1,.8.81A.8.8,0,0,1,296,352.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 355.51,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 348.06,
    width: 4.48,
    height: 18.5,
    transform: "translate(429.67 714.61) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,149.61H79.59L70,159.2V372.81l9.59,9.59H149l9.6-9.59V159.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70 372.81 79.59 382.4 101.13 382.4 91.53 372.81 70 372.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70 159.2 79.59 149.61 101.13 149.61 91.53 159.2 70 159.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.24,149.61H101.12l-9.59,9.59V372.81l9.59,9.59h86.12l9.59-9.59V159.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.35 377.92 96.01 371.59 96.01 160.42 102.35 154.09 186.02 154.09 192.35 160.42 192.35 371.59 186.02 377.92 102.35 377.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 165.45,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16,352.91a.81.81,0,1,0,.81-.8A.81.81,0,0,0,187.16,352.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,352.91a.8.8,0,1,0,.8-.8A.8.8,0,0,0,183.31,352.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,352.91a.8.8,0,1,0,.8-.8A.8.8,0,0,0,179.45,352.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 172.9,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 165.45,
    width: 4.48,
    height: 18.5,
    transform: "translate(196.5 349.4) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 185.74,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16,332.62a.81.81,0,1,0,.81-.8A.81.81,0,0,0,187.16,332.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,332.62a.8.8,0,1,0,.8-.8A.8.8,0,0,0,183.31,332.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,332.62a.8.8,0,1,0,.8-.8A.8.8,0,0,0,179.45,332.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 193.19,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 185.74,
    width: 4.48,
    height: 18.5,
    transform: "translate(196.5 389.98) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 206.03,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16,312.34a.81.81,0,1,0,.81-.81A.8.8,0,0,0,187.16,312.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,312.34a.8.8,0,1,0,1.6,0,.8.8,0,1,0-1.6,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,312.34a.8.8,0,1,0,.8-.81A.8.8,0,0,0,179.45,312.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 213.48,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 206.03,
    width: 4.48,
    height: 18.5,
    transform: "translate(196.5 430.56) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 226.32,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16,292.05a.81.81,0,1,0,.81-.81A.8.8,0,0,0,187.16,292.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,292.05a.8.8,0,1,0,1.6,0,.8.8,0,1,0-1.6,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,292.05a.8.8,0,1,0,.8-.81A.8.8,0,0,0,179.45,292.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 233.77,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 226.32,
    width: 4.48,
    height: 18.5,
    transform: "translate(196.5 471.14) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 246.61,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16,271.76A.81.81,0,1,0,188,271,.8.8,0,0,0,187.16,271.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,271.76a.8.8,0,1,0,1.6,0,.8.8,0,1,0-1.6,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,271.76a.8.8,0,1,0,.8-.81A.8.8,0,0,0,179.45,271.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 254.06,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 246.61,
    width: 4.48,
    height: 18.5,
    transform: "translate(196.5 511.72) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 266.9,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16,251.47a.81.81,0,0,0,1.61,0,.81.81,0,0,0-1.61,0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,251.47a.8.8,0,1,0,.8-.8A.8.8,0,0,0,183.31,251.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,251.47a.8.8,0,1,0,.8-.8A.8.8,0,0,0,179.45,251.47Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 274.35,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 266.9,
    width: 4.48,
    height: 18.5,
    transform: "translate(196.5 552.3) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 287.19,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16,231.18a.81.81,0,1,0,.81-.8A.8.8,0,0,0,187.16,231.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,231.18a.8.8,0,1,0,.8-.8A.8.8,0,0,0,183.31,231.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,231.18a.8.8,0,1,0,.8-.8A.8.8,0,0,0,179.45,231.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 294.64,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 287.19,
    width: 4.48,
    height: 18.5,
    transform: "translate(196.5 592.88) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 307.48,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16,210.89a.81.81,0,1,0,.81-.8A.8.8,0,0,0,187.16,210.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,210.89a.8.8,0,1,0,.8-.8A.8.8,0,0,0,183.31,210.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,210.89a.8.8,0,1,0,.8-.8A.8.8,0,0,0,179.45,210.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 314.93,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 307.48,
    width: 4.48,
    height: 18.5,
    transform: "translate(196.5 633.45) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 327.77,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16,190.6a.81.81,0,1,0,.81-.8A.8.8,0,0,0,187.16,190.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,190.6a.8.8,0,1,0,.8-.8A.8.8,0,0,0,183.31,190.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,190.6a.8.8,0,1,0,.8-.8A.8.8,0,0,0,179.45,190.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 335.22,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 327.77,
    width: 4.48,
    height: 18.5,
    transform: "translate(196.5 674.03) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 348.06,
    width: 91.86,
    height: 18.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.16,170.31a.81.81,0,1,0,.81-.8A.8.8,0,0,0,187.16,170.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,170.31a.8.8,0,1,0,.8-.8A.8.8,0,0,0,183.31,170.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,170.31a.8.8,0,1,0,.8-.8A.8.8,0,0,0,179.45,170.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 355.51,
    width: 91.86,
    height: 3.6,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 348.06,
    width: 4.48,
    height: 18.5,
    transform: "translate(196.5 714.61) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.83,95.18A14.84,14.84,0,0,0,168,80.46a14.64,14.64,0,0,0-5.55,1.08,17.93,17.93,0,0,0-33.62,4,15.43,15.43,0,0,0,1,30.83h49.11a10.93,10.93,0,0,0,3.9-21.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.27,80.5a19.63,19.63,0,0,0-27-18,23.73,23.73,0,0,0-44.48,5.25,20.42,20.42,0,0,0,1.33,40.79h65a14.47,14.47,0,0,0,5.15-28Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-44"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-44",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.52,401.47V400h-9a.76.76,0,0,0-.76.76h0a.76.76,0,0,0,.76.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.52,408v-1.52h-9a.76.76,0,0,0-.76.76h0a.76.76,0,0,0,.76.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3,396.24h0A1.26,1.26,0,0,0,82,397.51v13.21A1.26,1.26,0,0,0,83.3,412h0a1.26,1.26,0,0,0,1.26-1.27V397.51A1.26,1.26,0,0,0,83.3,396.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.88,398.09H83.3v12.05h3.58a6,6,0,0,0,6-6h0A6,6,0,0,0,86.88,398.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.12,412.36a64.42,64.42,0,0,1-7.72-.61l-4.4-.53c-.7,0-1.41.08-2.13.16-1,.1-2.05.27-3.05.42a30.27,30.27,0,0,1-5.81.54,2.86,2.86,0,0,1-1.19-.23,1.28,1.28,0,0,1,0-2.36,3,3,0,0,1,1.11-.27,32.58,32.58,0,0,1,6.64.33l4.5.54c1.82-.08,3.58,0,5.29,0a62.19,62.19,0,0,0,6.8-.08c2-.16,3.43-.84,3.51-1.14-.43-.52-1.54-.68-3.81-1-1.68-.21-3.82-.27-6.09-.33-1.78-.05-3.63-.1-5.52-.22-3.78-.26-8.64-.86-12.77-3.27a.44.44,0,0,1,.44-.76c4,2.33,8.71,2.91,12.38,3.16,1.88.12,3.72.17,5.5.22,2.28.06,4.45.12,6.17.34a21.68,21.68,0,0,1,2.95.48l-.11-.15c-.33-.43-.67-.86-1-1.33a6.4,6.4,0,0,1-1-2,2.75,2.75,0,0,1,.49-2.37,3.53,3.53,0,0,1,2.37-1,25,25,0,0,1,6.24.39.43.43,0,1,1-.13.86,24.31,24.31,0,0,0-6-.38,2.78,2.78,0,0,0-1.79.7,1.87,1.87,0,0,0-.31,1.62,5.78,5.78,0,0,0,.84,1.75c.28.43.6.85.92,1.26s.41.53.6.8l.1.14a3.38,3.38,0,0,1,.93,2.32c-.27,1.93-3,2-4.3,2ZM111,411.28a43,43,0,0,0,4.68.2c1.12,0,3.34-.06,3.51-1.25a.93.93,0,0,0,0-.4c-.74.78-2.71,1.2-4,1.31S112.39,411.28,111,411.28Zm-17.54-1q-.77,0-1.53.06a2.18,2.18,0,0,0-.78.18.41.41,0,0,0,0,.79,2.09,2.09,0,0,0,.84.15,29.6,29.6,0,0,0,5.64-.53l1.28-.2-.53-.06A42.55,42.55,0,0,0,93.5,410.29Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.11,171H130.32l-10,10V403.74l10,10h89.79l10-10V181Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "104.16 190.4 102.14 193.16 97 185.82 100.85 200.2 102.88 197.45 108.01 204.79 104.16 190.4",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.06 142.2 178.02 143.76 176.69 134.91 173.73 149.5 176.77 147.94 178.1 156.8 181.06 142.2",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.65 146.2 202.03 145.12 208.57 134.55 192.33 147.35 196.95 148.42 190.4 158.99 206.65 146.2",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.32 403.74 130.32 413.74 170.17 413.74 160.17 403.74 120.32 403.74",
    style: {
      fill: "#263238",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.32 181.01 130.32 171.01 170.17 171.01 160.17 181.01 120.32 181.01",
    style: {
      fill: "#263238",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,171H170.17c-3.91,3.91-6.09,6.1-10,10V403.74c3.91,3.9,6.09,6.09,10,10H260l10-10V181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.44 409.07 164.84 402.46 164.84 182.29 171.44 175.68 258.69 175.68 265.29 182.29 265.29 402.46 258.69 409.07 171.44 409.07",
    style: {
      fill: "#407BFF",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 187.53,
    width: 95.78,
    height: 19.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.88,192.6a.85.85,0,0,1,.84-.84.84.84,0,0,1,0,1.68A.85.85,0,0,1,259.88,192.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.86,192.6a.84.84,0,1,1,.83.84A.84.84,0,0,1,255.86,192.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.83,192.6a.84.84,0,1,1,.84.84A.85.85,0,0,1,251.83,192.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 195.3,
    width: 95.78,
    height: 3.75,
    style: {
      fill: "#407BFF"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 187.53,
    width: 4.67,
    height: 19.29,
    transform: "translate(334.35 394.36) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 208.69,
    width: 95.78,
    height: 19.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.72,
    cy: 213.75,
    r: 0.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.69,
    cy: 213.75,
    r: 0.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.67,
    cy: 213.75,
    r: 0.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 216.46,
    width: 95.78,
    height: 3.75,
    style: {
      fill: "#407BFF"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 208.69,
    width: 4.67,
    height: 19.29,
    transform: "translate(334.35 436.67) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 229.84,
    width: 95.78,
    height: 19.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.72,
    cy: 234.91,
    r: 0.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.69,
    cy: 234.91,
    r: 0.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.67,
    cy: 234.91,
    r: 0.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 237.61,
    width: 95.78,
    height: 3.75,
    style: {
      fill: "#407BFF"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 229.84,
    width: 4.67,
    height: 19.29,
    transform: "translate(334.35 478.98) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 251,
    width: 95.78,
    height: 19.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.72,
    cy: 256.06,
    r: 0.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.69,
    cy: 256.06,
    r: 0.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.67,
    cy: 256.06,
    r: 0.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 258.77,
    width: 95.78,
    height: 3.75,
    style: {
      fill: "#407BFF"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 251,
    width: 4.67,
    height: 19.29,
    transform: "translate(334.35 521.29) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 272.15,
    width: 95.78,
    height: 19.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.88,277.22a.85.85,0,0,1,.84-.84.84.84,0,0,1,0,1.68A.85.85,0,0,1,259.88,277.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.86,277.22a.84.84,0,1,1,.83.84A.84.84,0,0,1,255.86,277.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.83,277.22a.84.84,0,1,1,.84.84A.85.85,0,0,1,251.83,277.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 279.92,
    width: 95.78,
    height: 3.75,
    style: {
      fill: "#407BFF"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 272.15,
    width: 4.67,
    height: 19.29,
    transform: "translate(334.35 563.6) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 293.31,
    width: 95.78,
    height: 19.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.88,298.37a.84.84,0,0,1,.84-.83.84.84,0,0,1,0,1.67A.84.84,0,0,1,259.88,298.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.86,298.37a.84.84,0,1,1,.83.84A.83.83,0,0,1,255.86,298.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.83,298.37a.84.84,0,1,1,.84.84A.84.84,0,0,1,251.83,298.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 301.08,
    width: 95.78,
    height: 3.75,
    style: {
      fill: "#407BFF"
    }
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 293.31,
    width: 4.67,
    height: 19.29,
    transform: "translate(334.35 605.9) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 314.46,
    width: 95.78,
    height: 19.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.72,
    cy: 319.53,
    r: 0.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.69,
    cy: 319.53,
    r: 0.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.67,
    cy: 319.53,
    r: 0.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 322.23,
    width: 95.78,
    height: 3.75,
    style: {
      fill: "#407BFF"
    }
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 314.46,
    width: 4.67,
    height: 19.29,
    transform: "translate(334.35 648.21) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 335.62,
    width: 95.78,
    height: 19.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.72,
    cy: 340.68,
    r: 0.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.69,
    cy: 340.68,
    r: 0.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.67,
    cy: 340.68,
    r: 0.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 343.39,
    width: 95.78,
    height: 3.75,
    style: {
      fill: "#407BFF"
    }
  }), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 335.62,
    width: 4.67,
    height: 19.29,
    transform: "translate(334.35 690.52) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 356.77,
    width: 95.78,
    height: 19.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.72,
    cy: 361.84,
    r: 0.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.69,
    cy: 361.84,
    r: 0.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.67,
    cy: 361.84,
    r: 0.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 364.54,
    width: 95.78,
    height: 3.75,
    style: {
      fill: "#407BFF"
    }
  }), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 356.77,
    width: 4.67,
    height: 19.29,
    transform: "translate(334.35 732.83) rotate(180)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 377.93,
    width: 95.78,
    height: 19.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.72,
    cy: 382.99,
    r: 0.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.69,
    cy: 382.99,
    r: 0.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.67,
    cy: 382.99,
    r: 0.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 385.7,
    width: 95.78,
    height: 3.75,
    style: {
      fill: "#407BFF"
    }
  }), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 377.93,
    width: 4.67,
    height: 19.29,
    transform: "translate(334.35 775.14) rotate(180)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "171.44 409.07 164.84 402.46 164.84 182.29 171.44 175.68 223.12 175.68 229.72 182.29 229.72 402.46 223.12 409.07 171.44 409.07",
    style: {
      fill: "#407BFF",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.12 409.07 229.72 402.46 229.72 182.29 223.12 175.68 225.71 175.68 231.38 181.35 231.38 403.4 225.71 409.07 223.12 409.07 223.12 409.07",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.18,179.71c2.18,4.26,4.1,8.49,5.88,12.91.88,2.2,1.72,4.45,2.48,6.75a56,56,0,0,1,2,7.32l.09.5.05.27.05.37c0,.24.07.5.09.74l0,.66a17,17,0,0,1-.11,2.33,35.26,35.26,0,0,1-.73,3.95,66.55,66.55,0,0,1-2.2,7,99.09,99.09,0,0,1-5.94,12.95,2.74,2.74,0,0,1-5.08-1.94l0-.06c1-4.42,2.11-8.9,3-13.26.46-2.18.83-4.36,1.09-6.42a26.05,26.05,0,0,0,.2-2.91,8.73,8.73,0,0,0-.07-1.13l0-.21,0-.11-.06-.21-.1-.35c-.54-1.83-1.31-3.87-2.13-5.9s-1.72-4.07-2.65-6.12c-1.84-4.08-3.78-8.23-5.68-12.26l0-.06a5.5,5.5,0,0,1,9.88-4.85Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.33,234.89l3.41-5,3.39-1c1.56,1.9,1.11,4.83.65,6.51h0l-1,6.26a2.68,2.68,0,0,1-2.3,2.24l-2.23.32a2.91,2.91,0,0,1-3.31-2.64l-.09-1.08A8.61,8.61,0,0,1,353.33,234.89Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.76,248.4A5,5,0,0,0,349,245l16.82-7.81.13.12a5.05,5.05,0,0,0,7.11-.61,5,5,0,0,0,.86-1.49l-3.65.5a1.72,1.72,0,0,1-1.94-1.55l-.11-1.26a1.71,1.71,0,0,1,1.65-1.86l3.69-.14a5.3,5.3,0,0,0-1.11-1.31,5,5,0,0,0-8.29,4l-16.83,7.81-.12-.12a5.05,5.05,0,0,0-7.11.61,5.33,5.33,0,0,0-.87,1.48l3.66-.49a1.72,1.72,0,0,1,1.94,1.55l.1,1.26a1.71,1.71,0,0,1-1.64,1.86l-3.69.13a4.79,4.79,0,0,0,1.11,1.32A5,5,0,0,0,347.76,248.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.61,243h0a1,1,0,0,1,.49-1.35l13.46-6.24a1,1,0,0,1,1.35.49h0a1,1,0,0,1-.49,1.34L350,243.46A1,1,0,0,1,348.61,243Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.33,169.28c6,1.32,9,4.4,14.8,14.1-3.3,4.89-11.37,9.12-11.37,9.12l-3.5-4c-4.38-8.13.07-19.2.07-19.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.34,180.35a17.5,17.5,0,0,0,1.92,8.13l3.49,4s1.27-.67,3-1.78C349.91,185,347.68,182.15,344.34,180.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55,178.58l-.11.63-.1.48-.21.89c-.16.57-.34,1.13-.53,1.67a26.34,26.34,0,0,1-1.37,3.17,24.27,24.27,0,0,1-4,5.65,23.22,23.22,0,0,1-5.5,4.27,25.28,25.28,0,0,1-6.31,2.49l-.35.09a4.85,4.85,0,0,1-5.88-3.52,4.51,4.51,0,0,1-.12-.72,20.74,20.74,0,0,1,.35-6,37.84,37.84,0,0,1,1.47-5.19,59.73,59.73,0,0,1,4.33-9.11,96.89,96.89,0,0,1,5.32-8.16c1.93-2.6,3.87-5.1,6.08-7.54a2.73,2.73,0,0,1,4.39,3.2l0,.07c-1.51,2.59-3.05,5.3-4.44,8s-2.74,5.42-3.92,8.16a60.6,60.6,0,0,0-2.94,8.18,18.26,18.26,0,0,0-.74,7.22l-6.36-4.15a18.43,18.43,0,0,0,3.69-1.94,15.92,15.92,0,0,0,2.94-2.67,17.19,17.19,0,0,0,2.19-3.34,14.54,14.54,0,0,0,.81-1.86c.12-.31.21-.63.31-.93l.13-.44.05-.19s0-.16,0,0a5.5,5.5,0,1,1,10.87,1.67Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.09,177.83c.62-3.76-2-8.27-2-8.27-6,.29-11.72,1.75-17.24,13.05,1.33,6.3,9.68,10.74,9.68,10.74l5.89-7.64S320.46,181.6,321.09,177.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.23,154.88l1.66-1.8a6.62,6.62,0,0,1,2.61-1.72l1.58-.57a3.08,3.08,0,0,1,4.05,2.32l.39,2.08a3.07,3.07,0,0,1-2.15,3.52l-2.43.71a6.9,6.9,0,0,1-8.54,2.65A10.53,10.53,0,0,1,313.23,154.88Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.83,398.09h-8.32s.4,6.09.37,9.7l7.34.88C355.59,404.67,356.83,398.09,356.83,398.09Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.17,226.93s14.93,63.27,19.59,89c4.89,27,8.22,81.17,8.21,83.15,2.68-.53,7-.65,9.15,0,0,0,10.28-63.7,1-87.35-3.53-44.84,1-70.21-8-84.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.18,246.55c-2.44-10-10.72-9-16.11-7.18,3.36,14.45,8.93,38.78,13,58.08C341.85,283.59,342.48,260,339.18,246.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.84,397c-.75,9.67-8.6,20.07-8.6,20.07l12.11-3.1,5.1-7.58a35.77,35.77,0,0,1,1.13-8.55Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,226.93s2.11,67.32,1.56,87c-.77,27.28-6.49,85.16-6.49,85.16,4.34-.45,8.09-.58,10.49,0,0,0,18-46.86,15.89-84.9,4.5-35.25,19.66-67.63,10.29-87.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.07,151c-1.18,5.1-2.51,14.45.94,17.86a27.33,27.33,0,0,1-12.66,10.39c-6.68-4.28-3.2-10.39-3.2-10.39,5.74-1.36,5.74-5.58,4.89-9.55Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.07,163.57s-11.6-1.58-17.3,3.16a5.12,5.12,0,0,1-1.39,3.15,57,57,0,0,0,18.93.93C342.82,168.22,341.07,163.57,341.07,163.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.22,180.8c.62,16-2.9,40.33-1.2,46.13,17.16,1.74,30.57,1.45,42.11,0,2-6.33-2.76-25.13,2.71-47.5a8.23,8.23,0,0,0-7.15-10.25c-1.48-.15-3.06-.28-4.68-.36a111.82,111.82,0,0,0-15.86,0c-2,.18-4.12.45-6.08.74C313.49,170.37,309,175.2,309.22,180.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.24,142.38c-.07.7-.49,1.24-.94,1.21s-.76-.61-.69-1.31.48-1.23.93-1.2S321.3,141.69,321.24,142.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.74,141.13l-1.61-.59S319.85,141.9,320.74,141.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.35,137.82a.37.37,0,0,1-.25-.18.41.41,0,0,1,.15-.56,4,4,0,0,1,3.69-.44.4.4,0,0,1,.18.54.41.41,0,0,1-.54.21,3.18,3.18,0,0,0-2.92.38A.43.43,0,0,1,320.35,137.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.1,144.3a19.43,19.43,0,0,1-2.87,4.28,2.88,2.88,0,0,0,2.41.62Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.73,141c-1.32,8.5-1.7,12.13-6.38,16.25-7,6.2-17.07,3.06-18.29-5.59-1.09-7.78,1.25-20.38,9.84-23.27A11.23,11.23,0,0,1,344.73,141Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.52,131.38c-1.71,3.37,1.66,9.62,3.92,12.18-4,4.33-8,11.8-2.73,16.28,4.86,4.08,30.92,4,25.85-4.74,4.47-5.5-3-6.28.58-17,2.59-7.77-2.28-9.93-6.65-9.19C339.51,122.65,327.07,124.37,323.52,131.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.43,134.91s8.06,6.6,17.34,7.68c5,.58,7.5.51,7.73-.25s.66-3.32.66-3.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.59,133.18c2.44,1.93,20.88,7.2,33.31,6,.12-.74-.28-.83-.28-.83s2.86-9.59-3.71-13.19c-3.1-5.07-12.46-4.76-16.6-3.33l-.59.74s-8.11,1.89-8.23,8.61C319.29,131.59,315.9,131.06,318.59,133.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.72,122.61l.59-.74a17,17,0,0,1,12,4C340.2,124,335,122.25,330.72,122.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.22,140.86c-1.77-.24-3.45,2.34-4.06,4.18-.67,2.06.06,4,1.9,3.3a6.66,6.66,0,0,0,3.42-3.14C328.45,143.35,328,141.09,326.22,140.86Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.41,402.2c5.11-.9,5,1.74,5.34,4.57a8.14,8.14,0,0,1-.84,5c-1.8,3.17-.26,7.85-6,7.85s-6.25-1.33-4.71-4.16a32.2,32.2,0,0,0,3-9.09C348.59,404.73,349.14,402.6,351.41,402.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.42,408.25c0,3.43.06,11.37.06,11.37l-.91,0s-.78-8.45-1.27-10.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.1,403.33a6.25,6.25,0,0,1,.47,2.88c-.21,3.62-1,13.24-1,13.24h-.83a84,84,0,0,0-.08-8.85c-.31-2.39-1.49,1.83-3.15,4.21s-4.82,4.56-10.22,4.73c-6.32.2-8.87-.07-7-1.65s6.13-2.62,6.13-2.62a17.08,17.08,0,0,0,7.94-7.15,15.15,15.15,0,0,1,6.61-5.88A1.62,1.62,0,0,1,313.1,403.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-500--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.73,69.5h13v4.36h-8.8l-.47,3a9.57,9.57,0,0,1,1.81-.64A7.21,7.21,0,0,1,104,76a6.61,6.61,0,0,1,4.79,1.79,6,6,0,0,1,1.84,4.5,7.62,7.62,0,0,1-1,3.66A6.41,6.41,0,0,1,107,88.58a9.41,9.41,0,0,1-4.45.93,13,13,0,0,1-3.34-.37A6.61,6.61,0,0,1,96.87,88a6.51,6.51,0,0,1-1.58-1.66,8.57,8.57,0,0,1-1-2.31l5.53-.6a3.39,3.39,0,0,0,.94,2,2.5,2.5,0,0,0,1.76.69,2.41,2.41,0,0,0,1.89-.86,3.92,3.92,0,0,0,.74-2.59,3.75,3.75,0,0,0-.75-2.58,2.6,2.6,0,0,0-2-.81,3.33,3.33,0,0,0-1.53.38,4.39,4.39,0,0,0-1.21,1L95,80.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.85,79.25c0-3.74.67-6.35,2-7.85s3.4-2.24,6.15-2.24a9.16,9.16,0,0,1,3.27.49,6.16,6.16,0,0,1,2.08,1.27,7.13,7.13,0,0,1,1.27,1.66,9,9,0,0,1,.74,2,18.62,18.62,0,0,1,.55,4.59q0,5.36-1.81,7.84t-6.24,2.48a8.74,8.74,0,0,1-4-.79,6.56,6.56,0,0,1-2.51-2.32,8.82,8.82,0,0,1-1.1-3A19.81,19.81,0,0,1,112.85,79.25Zm5.42,0a13.15,13.15,0,0,0,.67,5.13,2.05,2.05,0,0,0,3.37.8,3.77,3.77,0,0,0,.9-1.85,19.61,19.61,0,0,0,.28-3.93,13.81,13.81,0,0,0-.66-5.27,2.13,2.13,0,0,0-2-1.35,2,2,0,0,0-2,1.37A14.26,14.26,0,0,0,118.27,79.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.19,79.25c0-3.74.67-6.35,2-7.85s3.4-2.24,6.15-2.24a9.1,9.1,0,0,1,3.26.49,6.21,6.21,0,0,1,2.09,1.27A7.08,7.08,0,0,1,146,72.58a8.51,8.51,0,0,1,.75,2,18.62,18.62,0,0,1,.55,4.59c0,3.57-.61,6.18-1.81,7.84s-3.29,2.48-6.25,2.48a8.72,8.72,0,0,1-4-.79,6.49,6.49,0,0,1-2.51-2.32,9,9,0,0,1-1.11-3A20.53,20.53,0,0,1,131.19,79.25Zm5.42,0a13.4,13.4,0,0,0,.66,5.13,2.1,2.1,0,0,0,1.93,1.38,2,2,0,0,0,1.44-.58,3.61,3.61,0,0,0,.9-1.85,18.73,18.73,0,0,0,.29-3.93,13.81,13.81,0,0,0-.66-5.27,2.13,2.13,0,0,0-2-1.35,2,2,0,0,0-2,1.37A14.56,14.56,0,0,0,136.61,79.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.13,89.18V69.5h2.6V89.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,89.18V74.92h2.17v2a5.12,5.12,0,0,1,4.54-2.35,5.93,5.93,0,0,1,2.37.46,3.76,3.76,0,0,1,1.62,1.21,5,5,0,0,1,.75,1.79,13.93,13.93,0,0,1,.13,2.35v8.77h-2.41V80.5a6.46,6.46,0,0,0-.29-2.21,2.29,2.29,0,0,0-1-1.16,3.19,3.19,0,0,0-1.68-.44,4,4,0,0,0-2.67,1c-.74.65-1.12,1.89-1.12,3.72v7.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.58,87l.35,2.14a9.16,9.16,0,0,1-1.82.21,4.2,4.2,0,0,1-2-.41,2.25,2.25,0,0,1-1-1.1,8.5,8.5,0,0,1-.3-2.85V76.8H181V74.92h1.77V71.39l2.4-1.45v5h2.43V76.8h-2.43v8.33a4.32,4.32,0,0,0,.13,1.33,1,1,0,0,0,.42.47,1.53,1.53,0,0,0,.82.18A6.94,6.94,0,0,0,187.58,87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.71,84.58l2.49.31a6.07,6.07,0,0,1-2.19,3.4,7.4,7.4,0,0,1-9-.72,7.51,7.51,0,0,1-1.83-5.4A7.92,7.92,0,0,1,191,76.58a6.3,6.3,0,0,1,4.81-2,6.11,6.11,0,0,1,4.67,1.94A7.74,7.74,0,0,1,202.28,82c0,.14,0,.36,0,.65H191.64A5.45,5.45,0,0,0,193,86.26a4,4,0,0,0,3,1.25,3.69,3.69,0,0,0,2.27-.7A4.68,4.68,0,0,0,199.71,84.58Zm-7.94-3.9h8a4.79,4.79,0,0,0-.91-2.7,3.71,3.71,0,0,0-3-1.4A3.85,3.85,0,0,0,193,77.7,4.38,4.38,0,0,0,191.77,80.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.21,89.18V74.92h2.17v2.16a6,6,0,0,1,1.54-2,2.7,2.7,0,0,1,1.55-.48,4.74,4.74,0,0,1,2.49.78l-.84,2.24a3.45,3.45,0,0,0-1.77-.53,2.28,2.28,0,0,0-1.42.48,2.61,2.61,0,0,0-.9,1.32,9.38,9.38,0,0,0-.4,2.82v7.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.39,89.18V74.92h2.18v2a5.11,5.11,0,0,1,4.53-2.35,5.93,5.93,0,0,1,2.37.46,3.76,3.76,0,0,1,1.62,1.21,4.65,4.65,0,0,1,.75,1.79,13.64,13.64,0,0,1,.14,2.35v8.77h-2.42V80.5a6.5,6.5,0,0,0-.28-2.21,2.34,2.34,0,0,0-1-1.16,3.2,3.2,0,0,0-1.69-.44,3.92,3.92,0,0,0-2.66,1c-.75.65-1.12,1.89-1.12,3.72v7.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,87.42A9.22,9.22,0,0,1,236.4,89a7.52,7.52,0,0,1-2.66.47,5.15,5.15,0,0,1-3.61-1.15,3.77,3.77,0,0,1-1.27-2.93,3.91,3.91,0,0,1,.48-1.92,4,4,0,0,1,1.25-1.39,6,6,0,0,1,1.74-.79,19.05,19.05,0,0,1,2.15-.36,22,22,0,0,0,4.3-.83c0-.33,0-.54,0-.63a2.64,2.64,0,0,0-.69-2.08,4,4,0,0,0-2.75-.82,4.36,4.36,0,0,0-2.52.59,3.69,3.69,0,0,0-1.2,2.12L229.28,79a5.82,5.82,0,0,1,1.06-2.45,4.68,4.68,0,0,1,2.13-1.44,9.47,9.47,0,0,1,3.24-.5,8.48,8.48,0,0,1,3,.43,3.73,3.73,0,0,1,1.67,1.08,3.84,3.84,0,0,1,.76,1.64,13.74,13.74,0,0,1,.12,2.23V83.2a35,35,0,0,0,.15,4.26,5.45,5.45,0,0,0,.61,1.72h-2.52A5.17,5.17,0,0,1,239,87.42Zm-.21-5.4a17.49,17.49,0,0,1-3.94.91,9.28,9.28,0,0,0-2.11.49,2.11,2.11,0,0,0-.95.78,2.13,2.13,0,0,0,.39,2.76,3.15,3.15,0,0,0,2.14.65A5,5,0,0,0,236.8,87a3.72,3.72,0,0,0,1.59-1.67,5.79,5.79,0,0,0,.39-2.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.92,89.18V69.5h2.42V89.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.75,84.92l2.39-.38a3.39,3.39,0,0,0,1.12,2.21,3.92,3.92,0,0,0,2.57.76,3.72,3.72,0,0,0,2.47-.68,2,2,0,0,0,.81-1.59A1.49,1.49,0,0,0,266.4,84a11.27,11.27,0,0,0-2.47-.82A21.85,21.85,0,0,1,260.24,82a3.49,3.49,0,0,1-1.55-1.35,3.55,3.55,0,0,1-.53-1.91,3.68,3.68,0,0,1,.43-1.77,4,4,0,0,1,1.19-1.35,4.92,4.92,0,0,1,1.54-.7,7,7,0,0,1,2.08-.29,8.29,8.29,0,0,1,3,.48,4,4,0,0,1,1.87,1.31,5.14,5.14,0,0,1,.84,2.21l-2.37.32a2.54,2.54,0,0,0-.93-1.72,3.41,3.41,0,0,0-2.18-.62,4,4,0,0,0-2.38.55,1.62,1.62,0,0,0-.71,1.29,1.32,1.32,0,0,0,.3.85,2.06,2.06,0,0,0,.92.64c.25.09,1,.3,2.14.62a30.93,30.93,0,0,1,3.58,1.12A3.72,3.72,0,0,1,269,82.92a3.56,3.56,0,0,1,.57,2.07,4,4,0,0,1-.7,2.27,4.56,4.56,0,0,1-2,1.65,7.33,7.33,0,0,1-3,.59,6.71,6.71,0,0,1-4.24-1.16A5.38,5.38,0,0,1,257.75,84.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.23,84.58l2.49.31a6.11,6.11,0,0,1-2.18,3.4,7.42,7.42,0,0,1-9.05-.72,7.51,7.51,0,0,1-1.83-5.4,7.92,7.92,0,0,1,1.85-5.59,6.3,6.3,0,0,1,4.81-2A6.11,6.11,0,0,1,283,76.54,7.74,7.74,0,0,1,284.8,82c0,.14,0,.36,0,.65H274.16a5.45,5.45,0,0,0,1.33,3.59,4,4,0,0,0,3,1.25,3.69,3.69,0,0,0,2.27-.7A4.68,4.68,0,0,0,282.23,84.58Zm-7.94-3.9h8a4.79,4.79,0,0,0-.91-2.7,3.71,3.71,0,0,0-3-1.4,3.85,3.85,0,0,0-2.8,1.12A4.38,4.38,0,0,0,274.29,80.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.73,89.18V74.92h2.17v2.16a6,6,0,0,1,1.54-2A2.7,2.7,0,0,1,293,74.6a4.74,4.74,0,0,1,2.49.78l-.84,2.24a3.45,3.45,0,0,0-1.77-.53,2.28,2.28,0,0,0-1.42.48,2.61,2.61,0,0,0-.9,1.32,9.38,9.38,0,0,0-.4,2.82v7.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87,89.18l-5.42-14.26H298l3.06,8.54c.33.92.64,1.88.91,2.87.22-.75.52-1.66.9-2.71l3.17-8.7h2.48l-5.39,14.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.42,84.58l2.5.31a6.18,6.18,0,0,1-2.19,3.4,6.57,6.57,0,0,1-4.08,1.21,6.49,6.49,0,0,1-5-1.93,7.48,7.48,0,0,1-1.84-5.4,7.88,7.88,0,0,1,1.86-5.59,6.26,6.26,0,0,1,4.8-2,6.1,6.1,0,0,1,4.67,1.94A7.75,7.75,0,0,1,323,82c0,.14,0,.36,0,.65H312.35a5.45,5.45,0,0,0,1.33,3.59,4,4,0,0,0,3,1.25,3.67,3.67,0,0,0,2.27-.7A4.68,4.68,0,0,0,320.42,84.58Zm-7.94-3.9h8a4.86,4.86,0,0,0-.92-2.7,3.7,3.7,0,0,0-3-1.4,3.86,3.86,0,0,0-2.8,1.12A4.42,4.42,0,0,0,312.48,80.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.92,89.18V74.92h2.18v2.16a5.83,5.83,0,0,1,1.53-2,2.71,2.71,0,0,1,1.56-.48,4.7,4.7,0,0,1,2.48.78l-.83,2.24a3.49,3.49,0,0,0-1.78-.53,2.3,2.3,0,0,0-1.42.48,2.61,2.61,0,0,0-.9,1.32,9.38,9.38,0,0,0-.4,2.82v7.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5,84.58l2.5.31a6.07,6.07,0,0,1-2.19,3.4,7.4,7.4,0,0,1-9-.72,7.51,7.51,0,0,1-1.83-5.4,7.92,7.92,0,0,1,1.85-5.59,6.3,6.3,0,0,1,4.81-2,6.13,6.13,0,0,1,4.67,1.94A7.74,7.74,0,0,1,355.08,82c0,.14,0,.36,0,.65H344.44a5.45,5.45,0,0,0,1.32,3.59,4,4,0,0,0,3,1.25,3.65,3.65,0,0,0,2.27-.7A4.54,4.54,0,0,0,352.5,84.58Zm-7.93-3.9h8a4.86,4.86,0,0,0-.91-2.7,3.72,3.72,0,0,0-3-1.4,3.86,3.86,0,0,0-2.8,1.12A4.41,4.41,0,0,0,344.57,80.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,89.18V74.92h2.17v2.16a6,6,0,0,1,1.54-2,2.7,2.7,0,0,1,1.55-.48,4.7,4.7,0,0,1,2.48.78l-.83,2.24a3.45,3.45,0,0,0-1.77-.53,2.28,2.28,0,0,0-1.42.48,2.61,2.61,0,0,0-.9,1.32,9.37,9.37,0,0,0-.41,2.82v7.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.16,89.18V74.92h2.18v2.16a5.71,5.71,0,0,1,1.54-2,2.66,2.66,0,0,1,1.55-.48,4.7,4.7,0,0,1,2.48.78l-.83,2.24a3.49,3.49,0,0,0-1.78-.53,2.3,2.3,0,0,0-1.42.48,2.61,2.61,0,0,0-.9,1.32,9.38,9.38,0,0,0-.4,2.82v7.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.45,82.05q0-4,2.2-5.87a6.65,6.65,0,0,1,4.48-1.58,6.43,6.43,0,0,1,4.81,1.92,7.36,7.36,0,0,1,1.86,5.33,9.48,9.48,0,0,1-.82,4.33,5.87,5.87,0,0,1-2.41,2.45,7,7,0,0,1-3.44.87,6.42,6.42,0,0,1-4.84-1.92A7.66,7.66,0,0,1,375.45,82.05Zm2.48,0a6.12,6.12,0,0,0,1.19,4.1,4,4,0,0,0,6,0A6.23,6.23,0,0,0,386.32,82a5.89,5.89,0,0,0-1.2-4,4,4,0,0,0-6,0A6.1,6.1,0,0,0,377.93,82.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.61,89.18V74.92h2.17v2.16a6,6,0,0,1,1.54-2,2.7,2.7,0,0,1,1.55-.48,4.68,4.68,0,0,1,2.48.78l-.83,2.24a3.45,3.45,0,0,0-1.77-.53,2.28,2.28,0,0,0-1.42.48,2.61,2.61,0,0,0-.9,1.32,9.37,9.37,0,0,0-.41,2.82v7.47Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg500InternalServerErrorRafiki);
export default __webpack_public_path__ + "static/media/500 Internal Server Error-rafiki.4056848584771ab087fb278a79093699.svg";
export { ForwardRef as ReactComponent };